/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contactMultiValueItemResponseDtoSchema } from "./contactMultiValueItemResponseDtoSchema";
import { z } from "zod/v4";

export const contactResponseDtoSchema = z.object({
    "id": z.string(),
"tenantId": z.string(),
"firstName": z.nullable(z.string()),
"lastName": z.nullable(z.string()),
"fullName": z.nullable(z.string()),
"preferredName": z.nullable(z.string()),
get "email"(){
               return z.array(contactMultiValueItemResponseDtoSchema).nullable()
              },
get "phone"(){
               return z.array(contactMultiValueItemResponseDtoSchema).nullable()
              },
get "links"(){
               return z.array(contactMultiValueItemResponseDtoSchema).nullable()
              },
"company": z.nullable(z.string()),
"title": z.nullable(z.string()),
"timezone": z.nullable(z.string()),
"address": z.nullable(z.string()),
"city": z.nullable(z.string()),
"state": z.nullable(z.string()),
"postalCode": z.nullable(z.string()),
"sources": z.nullable(z.array(z.string())),
"isMonitoredSince": z.nullable(z.iso.datetime()),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    })